import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["description", "imageSrc", "name", "onClick", "use"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { Image } from 'foundations-components/transitional/components/Image';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function CollectionCard(_ref) {
  let {
      description,
      imageSrc,
      name,
      onClick,
      use = 'default'
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(CardWrapper, {
    children: /*#__PURE__*/_jsxs(Flex, Object.assign({
      backgroundColor: use === 'on-dark' ? 'fill-surface-default' : 'fill-surface-raised',
      borderRadius: "100",
      gap: "800",
      padding: "800"
    }, restProps, {
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "start",
        flexDirection: "column",
        flexGrow: "1",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h5",
          children: name
        }), /*#__PURE__*/_jsx(Text, {
          marginBlockStart: "200",
          marginBlockEnd: "400",
          children: description
        }), /*#__PURE__*/_jsx(Button, {
          onClick: onClick,
          marginBlockStart: "auto",
          use: "tertiary-extra-light",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.collectionCard.viewCollection"
          })
        })]
      }), /*#__PURE__*/_jsx(Flex, {
        flexShrink: "0",
        children: /*#__PURE__*/_jsx(Image, {
          src: imageSrc,
          inlineSize: "150px",
          objectFit: "contain"
        })
      })]
    }))
  });
}